import { Yield } from '../../abacus/interfaces/yield.interface'

export const geographicalScopeYields: Yield[] = [
  {
    label: 'Name',
    property: 'name'
  },
  {
    label: 'Description',
    property: 'description'
  }
]
